import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Button, Form, Card, Carousel, Navbar, Nav } from "react-bootstrap";
import { FaSearch, FaAngleDoubleRight, FaArrowLeft, FaHeart, FaAngleRight, FaMapMarkerAlt, FaHome, FaList } from "react-icons/fa";

import axios from 'axios';
import { site_url, site_url_img } from "./../config.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import { useLocation } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { FaStar,FaUserCircle  } from "react-icons/fa";
import { format } from "date-fns";
import {  Link } from "react-router-dom";
import { Navigate, useNavigate } from 'react-router-dom';
import { AuthContext } from './../AuthContext';








function Index() {
  const [productcategorydata, setproductcategorydata] = useState([]);
  const navigate = useNavigate();
  const { user,fulluser } = useContext(AuthContext);

    const location = useLocation();
    const category = location.state?.category;
    const goBack = () => {
        window.history.back(); // Goes back to the previous page
      };

      useEffect(() => {
        console.log(category);
        productsubcategory();
      },[category]);

      const productsubcategory = async () => {
        try {
    
          const response = await axios.get(site_url + '/vendor/shopscategory/'+category.id);
    
          if (response.data.status == 'success') {
    
             setproductcategorydata(response.data.data);
          }
        } catch (error) {
    
        }
      }




  return (
    <div><div className="min-vh-100">
    {/* Navbar */}
    <Navbar expand="lg" className="navbar px-3">

        <Navbar.Brand className="fw-bold text-white"><center><FaArrowLeft onClick={goBack} className="fs-5 text-white notificaton-icon" /> {category?.name}</center></Navbar.Brand>
        <Nav className="ms-auto d-flex align-items-center">
        </Nav>
    </Navbar>
    <div className='p-2'>
    <div className="row justify-content-center mt-0 p-2">
      <h4 className='p-2'>Shop List</h4>
      <div class="banner">
      <h2>💫𝙎𝙝𝙤𝙥𝙥𝙞𝙣𝙜 𝙂𝙪𝙞𝙙𝙚𝙡𝙞𝙣𝙚𝙨💼</h2>
          <ol>
            <li>Visit our outlets/stores <br></br>(Locaction other details available under each category.)</li>
            <li>Select the products.</li>
            <li>At Billing counter.
              Share your customer ID (10 digit Indian mobile phone number) and collect GST invoice</li>
            <li>Complete the payment only through <strong>APM SmartHub platform </strong> to enjoy all benefits.</li>
            <li>For delivery contact the store number.</li>
          </ol>
          <div class="note">
            <strong>Notes:</strong> Every amount, spent via <strong>APM SmartHub</strong> will be saved & earn unstoppable reward points.<br /><br />
            🪙 <strong>APM monthly Bonus day:</strong> On the 3rd of every following months, get flat 1% or 0.5% reward points from your total history for lifetime.
          </div>
          <div class="footer">
            💫 𝙃𝙖𝙥𝙥𝙮 𝙨𝙝𝙤𝙥𝙥𝙞𝙣𝙜! ✨
            <div style={{ textAlign: 'center', marginTop: '10px' }}>
              <strong>*T&C Apply*</strong>
            </div>
          </div>
</div>
</div>
    {productcategorydata.map((shop, index) => (
    <div className="col-12 p-2">
      <Link to={`/Shopdetails`} state={{ shop }}>
      <Col xs={12} key={index} className="">
                <Card >
                  <Card.Body>
                    <div className='row'>
                        <div className='col-4'>
                        <center><img src={site_url_img + '/' + shop.shop_img} className="shoplist_img" /></center>

                        </div>
                        <div className='col-8'>
                        <b><span className="shoplist_text">{shop.shop_name}</span></b>
                    <p className="shoplist_dcr">{shop.address}</p>
                    {(user != null ? 
                  <center><Link to={`/Shopdetails`} state={{ shop }}><Button className=''  variant="primary">Shop Details <FaAngleRight className="fs-4  sideicon-icon_a" /></Button></Link></center>
                   :
                   <center><Link to={`/signin`} state={{ shop }}><Button className=''  variant="primary">Shop Details <FaAngleRight className="fs-4  sideicon-icon_a" /></Button></Link></center>

                   )}
                      </div>
                    </div>
                 </Card.Body>

                </Card>
              </Col>
      </Link>
    </div>

       ))}
       </div>
    
    </div>
    </div>
  )
}
export default Index